module.exports = __webpack_public_path__ + "img/logo.b5c7cfd8.png";